import React, { useState } from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import i18n from '@i18next/i18n';
import { PasteSpecialType, IMenuProps } from '../interface';
import styles from './index.less';

/**
 * 选择性粘贴菜单组件
 */
const PasteSpecialMenu = (props: IMenuProps) => {
    const [selectedIdList, setSelectedId] = useState([PasteSpecialType.DESTINATION_THEME]);
    const handleMenuClick = (menuId) => {
        if (menuId === selectedIdList[0]) return;
        setSelectedId([menuId]);
        props.onMenuClick(menuId);
    };

    const getContainerClassName = (menuId) => {
        if (selectedIdList[0] === menuId) {
            return styles['menu-item-selected'];
        }
        return '';
    };

    return (
        <Menu onClick={handleMenuClick} selectedIds={selectedIdList}>
            <Menu.Item
                id={PasteSpecialType.SOURCE_FORMAT}
                containerClassName={getContainerClassName(PasteSpecialType.SOURCE_FORMAT)}
            >
                {i18n.t('保留源格式')}
            </Menu.Item>
            <Menu.Item
                id={PasteSpecialType.DESTINATION_THEME}
                containerClassName={getContainerClassName(PasteSpecialType.DESTINATION_THEME)}
            >
                {i18n.t('使用目标主题')}
            </Menu.Item>
            {
                props.showTextOnlyOption && (
                    <Menu.Item
                        id={PasteSpecialType.TEXT_ONLY}
                        containerClassName={getContainerClassName(PasteSpecialType.TEXT_ONLY)}
                    >
                        {i18n.t('只保留文本')}
                    </Menu.Item>
                )
            }
        </Menu>
    );
};

export default PasteSpecialMenu;
